// src/components/Logo.js
import React from "react";
import { Box, Link } from "@mui/material";

const Logo = () => {
  const homepageUrl = "https://www.alphabetsigns.com";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mr: 2,
        ml: 2,
      }}
    >
      <Link href={homepageUrl} underline="none">
        <img
          src="https://www.alphabetsigns.com/mm5/graphics/00000001/alphabet-signs-logo-450.png"
          alt="alphabet signs logo"
          style={{
            height: "40px", // Match toolbar height
            width: "auto",
            objectFit: "contain",
          }}
        />
      </Link>
    </Box>
  );
};

export default Logo;
